import Vue from 'vue'
import App from './App'
import router from './router' // 路由
import store from './store' // vuex
import "./utils/rem" // rem
import "./utils/reset.css" // 公共css样式
import "./utils/exclusive.css" // 专属css样式
import util from './utils/util'
import request from './utils/requestAxios'
Vue.prototype.$fun = util
Vue.prototype.$axios = request

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 注释引入手机端调试
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
// Vue.use(vConsole)

//animate
import animated from 'animate.css'
Vue.use(animated)

// vant框架引入
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


// 图片域名
Vue.prototype.baseURL = process.env.OSS_DOMAIN

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js